import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { colors } from '@/utils/colorSystem';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';

export default function DeleteProjectModal({
    open,
    onCancel,
    onConfirm,
    projectName,
    isDeleting
}) {
    const [inputValue, setInputValue] = useState('');

    // Reset input when modal opens/closes
    useEffect(() => {
        if (open) {
            setInputValue('');
        }
    }, [open]);

    const isConfirmed = inputValue.trim() === projectName;

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            width={480}
            centered
            destroyOnClose
            styles={{
                mask: { backdropFilter: 'blur(4px)' }
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', paddingTop: '20px' }}>
                <div style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '50%',
                    backgroundColor: colors.error?.[50] || '#fef2f2',
                    border: `1px solid ${colors.error?.[100] || '#fee2e2'}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '16px'
                }}>
                    <WarningOutlined style={{ fontSize: '24px', color: colors.error?.[500] || '#ef4444' }} />
                </div>

                <h3 style={{ fontSize: '18px', fontWeight: 700, color: colors.neutral[900], margin: '0 0 8px 0' }}>
                    Delete Project
                </h3>

                <p style={{ fontSize: '14px', color: colors.neutral[500], lineHeight: '20px', margin: '0 0 24px 0', padding: '0 16px' }}>
                    This action is permanent and cannot be undone. This will delete the project <strong style={{ color: colors.neutral[900] }}>{projectName}</strong>, all of its tasks, sprints, settings, and files.
                </p>

                <div style={{ width: '100%', textAlign: 'left', background: colors.neutral[50], border: `1px solid ${colors.neutral[200]}`, borderRadius: '12px', padding: '16px', marginBottom: '24px' }}>
                    <div style={{ fontSize: '12px', fontWeight: 600, color: colors.neutral[700], marginBottom: '8px' }}>
                        To confirm deletion, type <span style={{ fontFamily: 'monospace', fontSize: '13px', background: colors.neutral[200], padding: '2px 6px', borderRadius: '4px', color: colors.error?.[700] || '#b91c1c', fontWeight: 700 }}>{projectName}</span> below:
                    </div>
                    <Input
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder="Type project name to confirm"
                        disabled={isDeleting}
                        $variant="white"
                        $maxWidth="100%"
                        style={{ height: '38px', borderRadius: '8px' }}
                    />
                </div>

                <div style={{ display: 'flex', gap: '12px', width: '100%', justifyContent: 'flex-end' }}>
                    <Button 
                        $primary={false}
                        onClick={onCancel} 
                        disabled={isDeleting}
                        style={{ borderRadius: '8px', height: '38px' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        $dangerOutline
                        disabled={!isConfirmed}
                        loading={isDeleting}
                        onClick={onConfirm}
                        style={{ borderRadius: '8px', height: '38px' }}
                    >
                        Delete Permanently
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
